// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const borderStyle: string = `2px solid ${token('color.border')}`;

type ContextWidthType = {
	medium: string;
	large: string;
	xlarge: string;
	full: string;
};

export const maxContentWidth: ContextWidthType = {
	medium: '680px', // 552px (medium width) + 64px + 64px (padding left and right)
	large: '832px', // 704px (large width) + 64px + 64px (padding left and right)
	xlarge: '1048px', // 920px (xlarge width) + 64px + 64px (padding left and right)
	full: 'none',
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const FooterButtonsWrapper = styled.div({
	flexShrink: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> button': {
		marginRight: token('space.100'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'> button:last-child': {
		marginRight: 0,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const FooterInfoTextWrapper = styled.div({
	font: token('font.body'),
	color: token('color.text'),
	fontWeight: token('font.weight.semibold'),
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	alignSelf: 'center',
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterWrapper = styled.div<{ contentSize: string }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-flow: row nowrap;
	gap: ${token('space.100')};
	width: 100%;
	padding: ${token('space.200')} ${token('space.800')};
	box-sizing: border-box;
	flex-shrink: 0;
	margin: 0 auto 0 auto;
	max-width: ${({ contentSize }) => maxContentWidth[contentSize as keyof ContextWidthType]};

	@media (max-width: 479px) {
		flex-flow: column nowrap;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const HorizontalDivider = styled.hr({
	border: 0,
	margin: 0,
	width: '100%',
	borderBottom: borderStyle,
});
